import { createAction, createReducer } from "@reduxjs/toolkit";

const Current_Sidebar_Tab = createAction("Current_Sidebar_Tab");

const initialState = {
  sidebartabtext: "dashboard",
};

export const sidebartabReducer = createReducer(initialState, (builder) => {
  builder.addCase(Current_Sidebar_Tab, (state, action) => {
    state.sidebartabtext = action.payload;
  });
});
